var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{attrs:{"id":"qr-reader"}}),_c('div',{staticClass:"p-3"},[(_vm.error)?_c('div',[_vm._v(" 無法啟動手機相機鏡頭，請確定權限正確。若使用 iPhone，系統需為 14.3 版以上。 "),_vm._t("error")],2):_c('div',{staticClass:"text-center"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }